import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Signal } from '../../model/signal';
import { OktaAuthService } from '../../../app.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-signal-list',
  templateUrl: './signal-list.component.html',
  styleUrls: ['./signal-list.component.scss']
})
export class SignalListComponent implements OnInit {

  @Input()
  signals: Signal[];

  @Input()
  flagRefs: any[];

  @Input()
  flaggingRef: string;

  @Output()
  flagEmitter = new EventEmitter<any>();

  @Output()
  sortEmitter = new EventEmitter<any>();

  @Input()
  loaded: boolean;

  isWorldWatch_User = false;
  worldWatch_Group = environment.world_watch_group;
  userObject: any;

  constructor(private auth: OktaAuthService) { }

  ngOnInit() {
    this.auth.getUserDetails().then(val => {

      this.userObject = val;
      if(this.userObject.groups.indexOf(this.worldWatch_Group) > -1){
        this.isWorldWatch_User = true;
      }else{
        // if the user doesn't have worldwatch role
        this.isWorldWatch_User = false;
      }

    });
  }

  flagSignal(event, jiraRef: string): void {
    event.stopPropagation();
    this.flagEmitter.emit(jiraRef);
  }

  sortSignals(event, field: string): void {
    event.stopPropagation();
    this.sortEmitter.emit(field);
  }

}
